/**
 * Matrikar shared globals — fuel codes, brand logo mappings, and DB metadata.
 * Loaded after matrikar-data.js. Sections that need this data should reference
 * window.MATRIKAR_FUEL, window.MATRIKAR_LOGOS, and window.MATRIKAR_DB_META.
 */
(function () {
  window.MATRIKAR_FUEL = {
    P: 'Petrol/Diesel',
    E: 'Electric',
    PH: 'Plug-in Hybrid',
    FH: 'Full Hybrid',
    MH: 'Mild Hybrid',
    FC: 'Fuel Cell'
  };

  window.MATRIKAR_LOGOS = {
    'Acura': 'acura', 'Alfa Romeo': 'alfaromeo', 'Aston Martin': 'astonmartin', 'Audi': 'audi', 'AUDI': 'audi',
    'Bentley': 'bentley', 'BMW': 'bmw', 'Bugatti': 'bugatti', 'Buick': 'buick', 'BYD': 'byd', 'Cadillac': 'cadillac',
    'Chery': 'chery', 'Chevrolet': 'chevrolet', 'Chrysler': 'chrysler', 'Citroen': 'citroen', 'Cupra': 'cupra',
    'Dacia': 'dacia', 'Daewoo': 'daewoo', 'Datsun': 'datsun', 'Dodge': 'dodge', 'DS': 'ds', 'Fiat': 'fiat',
    'Ferrari': 'ferrari', 'Fisker': 'fisker', 'Ford': 'ford', 'Genesis': 'genesis', 'Geely': 'geely', 'GMC': 'gmc',
    'Great Wall': 'greatwall', 'Haval': 'haval', 'Holden': 'holden', 'Honda': 'honda', 'Hyundai': 'hyundai',
    'Infiniti': 'infiniti', 'Isuzu': 'isuzu', 'Jaguar': 'jaguar', 'Jeep': 'jeep', 'Kia': 'kia', 'Lada': 'lada',
    'Lamborghini': 'lamborghini', 'Lancia': 'lancia', 'Land Rover': 'landrover', 'Lexus': 'lexus', 'Lincoln': 'lincoln',
    'Lotus': 'lotus', 'Lucid': 'lucidmotors', 'Mahindra': 'mahindra', 'Maserati': 'maserati', 'Mazda': 'mazda',
    'McLaren': 'mclaren', 'Mercedes-Benz': 'mercedes', 'MG': 'mg', 'Mini': 'mini', 'Mitsubishi': 'mitsubishi',
    'NIO': 'nio', 'Nissan': 'nissan', 'Opel': 'opel', 'Pagani': 'pagani', 'Peugeot': 'peugeot', 'Polestar': 'polestar',
    'Pontiac': 'pontiac', 'Porsche': 'porsche', 'Proton': 'proton', 'RAM': 'ram', 'Renault': 'renault', 'Rivian': 'rivian',
    'Rolls-Royce': 'rollsroyce', 'Saab': 'saab', 'Seat': 'seat', 'Skoda': 'skoda', 'Smart': 'smart', 'SsangYong': 'ssangyong',
    'Subaru': 'subaru', 'Suzuki': 'suzuki', 'Tata': 'tata', 'Tesla': 'tesla', 'Toyota': 'toyota', 'Vauxhall': 'vauxhall',
    'VinFast': 'vinfast', 'Volkswagen': 'volkswagen', 'Volvo': 'volvo', 'XPENG': 'xpeng', 'Zeekr': 'zeekr'
  };

  window.MATRIKAR_DB_META = {
    version: 2,
    date: '2026-06-08',
    expectedMakes: 55,
    expectedRows: 10762,
    actualMakes: (window.MATRIKAR_DB && window.MATRIKAR_DB.makes) ? window.MATRIKAR_DB.makes.length : 0,
    actualRows: (window.MATRIKAR_DB && window.MATRIKAR_DB.data) ? window.MATRIKAR_DB.data.length : 0
  };
})();

/**
 * Years are now PRECOMPUTED in matrikar-data.js — one row per real sales year per
 * model (North-America-only, web-verified end-of-production, gaps removed). This
 * helper no longer expands ranges or extends to "current year + 1"; it simply
 * de-duplicates and returns the supplied years in descending order.
 * (Replaces the former runtime "expand-to-2027" logic — see DB rebuild 2026-06-08.)
 */
window.MATRIKAR_EXPAND_YEARS = function(years) {
  if (!years || !years.length) return [];
  var seen = {};
  var out = [];
  for (var i = 0; i < years.length; i++) {
    var s = String(years[i]);
    if (s && !seen[s]) { seen[s] = 1; out.push(s); }
  }
  out.sort(function(a, b) { return parseInt(b, 10) - parseInt(a, 10); });
  return out;
};

/**
 * Map any user-picked year back to its "generation start" year (closest <= year).
 * Used to look up trims/seats/fuel rows in DB which only stores generation years.
 * Example: gens=['2015','2018','2021'], userYear='2017' → '2015'
 */
window.MATRIKAR_GEN_YEAR = function(genYears, userYear) {
  var u = parseInt(userYear, 10);
  if (isNaN(u)) return userYear;
  var asc = [];
  for (var i = 0; i < genYears.length; i++) {
    var y = parseInt(genYears[i], 10);
    if (!isNaN(y)) asc.push(y);
  }
  if (!asc.length) return userYear;
  asc.sort(function(a,b){ return a - b; });
  var match = asc[0];
  for (var j = 0; j < asc.length; j++) {
    if (asc[j] <= u) match = asc[j];
    else break;
  }
  return String(match);
};
